import {LogLevel} from "angular-auth-oidc-client";

export const environment = {
  production: true,
  appName: 'PSA',
  appVersion: 'beta',
  manteinance: false,
  language: 'it',
  mockApiUrl:  'http://localhost:3002/api/v1' ,
  apiUrl: 'https://antea.iss.it/test/psa-ms/api/v1',
  notification:'http://localhost:3011/api/sse',
  apiSentrynelUrl: 'https://antea.iss.it/test/sentrynel-be/api',
  dashboardSentrynelUrl: 'https://antea.iss.it/test/sentrynel/',
  secure: true,
  keycloak: {
    authority: 'https://antea.iss.it/test/iam/',
    redirectUrl: 'https://antea.iss.it/test/psa/login_success', //'https://cot.we-com.local/',
    postLogoutRedirectUri: 'https://antea.iss.it/test/psa/',
    clientId: 'psa',
    scope: 'openid profile email',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    startCheckSession: true,
    logLevel: LogLevel.Error,
    historyCleanupOff: false,
    realms: 'antea'
  },
    googleMapsApiKey: "AIzaSyBuzr3xmTd-weYgeaRehm-q33J5EnQt-YA"
};
